import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "CertificacionDetallePage",
    data() {
        let ss = new MainService();
        return {
            msg: "CertificacionDetallePage",
            ss: ss,
            ajax: {
                "url": ss.indexCertificacionDetalle(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'Certificacion', name: 'Certificacion', title: 'Certificación' },
                { data: 'Reparticion', name: 'Reparticion', title: 'Repartición' },
                { data: 'CategoriaProgramatica', name: 'CategoriaProgramatica', title: 'Categoria Programática' },
                { data: 'Partida', name: 'Partida', title: 'Partida' },
                { data: 'Monto', name: 'Monto', title: 'Monto' },
                { data: 'Poa', name: 'Poa', title: 'Poa' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            reparticiones: [],
            categoriaProgramaticas: [],
            partidas: [],
            certificaciones: [],
            certificacionDetalles: [],
            certificacionDetalle: {},
            isLoading: false,
            isLoadingFile: false,
            errorBag: {},
            password: {},
            queryCertificacion: "",
         

        };
    },
    methods: {
      
        getCertificacion() {
            this.ss.listCertificacion().then(
                (result) => {
                    let response = result.data;
                    this.certificaciones = response.data;
                    console.log("certificacion");
                    console.log(this.certificaciones);
                }
            ).catch(error => {
                console.log(error);
            });
        },
        getReparticion() {
            this.ss.listReparticion(0).then(
                (result) => {
                    let response = result.data;
                    this.reparticiones = response.data;
                }
            ).catch(error => {
                console.log(error);
            });
        },
        getCategoriaProgramatica() {
            this.ss.listCategoriaProgramatica().then(
                (result) => {
                    let response = result.data;
                    this.categoriaProgramaticas = response.data;
                }
            ).catch(error => {
                console.log(error);
            });
        },
        getPartida() {
            this.ss.listPartida().then(
                (result) => {
                    let response = result.data;
                    this.partidas = response.data;
                }
            ).catch(error => {
                console.log(error);
            });
        },
        newCertificacionDetalle() {
            this.certificacionDetalle = {};
            this.$refs['frm-certificacionDetalle'].show();
        },
        showCertificacionDetalle(id) {
            this.isLoading=true;
            this.ss.showCertificacionDetalle(id).then(
                (result) => {
                  
                    let response = result.data;
                    this.certificacionDetalle = response.data;
                    console.log("show");
                    console.log(this.certificacionDetalle);
                    this.$refs['view-certificacionDetalle'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editCertificacionDetalle() {
            this.$refs['frm-certificacionDetalle'].show();
            this.$refs['view-certificacionDetalle'].hide();
        },
        cancelCertificacionDetalle() {
            if (this.certificacionDetalle.id) {
                this.$refs['view-certificacionDetalle'].show();
            }
            this.$refs['frm-certificacionDetalle'].hide();
        },
        saveCertificacionDetalle() {
            this.ss.storeCertificacionDetalle(this.certificacionDetalle).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-certificacionDetalle'].hide();
                    this.$refs['datatable-certificacionDetalle'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteCertificacionDetalle() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
                showCancelButton: true,
                cancelButtonColor: '#d33',
            })
                .then((willDelete) => {
                    if (willDelete.isConfirmed) {
                        this.ss.destroyCertificacionDetalle(this.certificacionDetalle)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-certificacionDetalle'].hide();
                                this.$refs['datatable-certificacionDetalle'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        cambiopassword() {
            this.$refs['view-certificacionDetalle'].hide();
            this.$refs['view-password'].show();
        },
        cancelPassword() {
            this.$refs['view-password'].hide();
            this.$refs['view-certificacionDetalle'].show();
        },
        changePassword() {
            this.password.CertificacionDetalle = this.certificacionDetalle.id;
            this.ss.changePassword(this.password)
                .then( result => {
                    let response = result.data;
                    if ( response.success ) {
                        this.$bvToast.toast(
                            response.msg,
                            {
                                title: 'Correcto',
                                variant: 'success',
                                autoHideDelay: 5000
                            }
                        )
                        this.$refs['view-password'].hide();
                        this.$refs['view-certificacionDetalle'].show();
                    } else {
                        this.$bvToast.toast(
                            response.msg,
                            {
                                title: 'Oops',
                                variant: 'danger',
                                autoHideDelay: 5000
                            }
                        )
                    }
                })
                .catch( error => {
                    console.log( error );
                    this.$bvToast.toast(
                        'Error al guardar el registro',
                        {
                            title: 'Oops',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                    this.errorBag = error.data.errors;
                })
        },
        draw() {
            window.$('.btn-datatable-CertificacionDetalle').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showCertificacionDetalle(data);
            });
        }
    },
    watch: {
        queryCertificacion(q) {
            this.ss.select2Certificacion(q).then((res) => {
                console.log(res);
                if (res.data.success) {
                    this.certificaciones = res.data.items;
                } else {
                    this.certificaciones = [];
                }
            })
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        var persona = JSON.parse(localStorage.getItem('persona'));
        if (!persona) {
            this.$router.push('/Login');
        } else {
            this.getCertificacion();
            this.getReparticion(0);
            this.getCategoriaProgramatica();
            this.getPartida();
        }
    }
};
